import { cn } from "@theprelude/core";

export const CalendarIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.3333 2.00033H13.9999C14.1767 2.00033 14.3463 2.07056 14.4713 2.19559C14.5963 2.32061 14.6666 2.49018 14.6666 2.66699V13.3337C14.6666 13.5105 14.5963 13.68 14.4713 13.8051C14.3463 13.9301 14.1767 14.0003 13.9999 14.0003H1.99992C1.82311 14.0003 1.65354 13.9301 1.52851 13.8051C1.40349 13.68 1.33325 13.5105 1.33325 13.3337V2.66699C1.33325 2.49018 1.40349 2.32061 1.52851 2.19559C1.65354 2.07056 1.82311 2.00033 1.99992 2.00033H4.66659V0.666992H5.99992V2.00033H9.99992V0.666992H11.3333V2.00033ZM9.99992 3.33366H5.99992V4.66699H4.66659V3.33366H2.66659V6.00033H13.3333V3.33366H11.3333V4.66699H9.99992V3.33366ZM13.3333 7.33366H2.66659V12.667H13.3333V7.33366Z" />
  </svg>
);
